// resources/js/stores/BoxIdStore.js
import { defineStore } from 'pinia';
import { loadLocalStorage, saveLocalStorage } from './utils/localStorage';

const storageKey = 'boxIdState';

export const useBoxIdStore = defineStore('BoxIdStore', {
  state: () => ({
    boxIdString: loadLocalStorage(storageKey, { boxIdString: '' }).boxIdString,
  }),
  actions: {
    setBoxIdString(value) {
      this.boxIdString = value ?? '';
      saveLocalStorage(storageKey, { boxIdString: this.boxIdString });
    },
  },
});
